const initialAppFilterState = {
  fetching: false,
  fetched: false,
  items: [],
  selected : [],
  error: null,
  nbResult: 0,
};


export const appRefFilterReducer = (state = initialAppFilterState, action) => {
  switch (action.type) {

    case "FETCH_DOCUMENTS_APP_REF_PENDING": {
      return {...state, fetched: false, fetching: true};
    }
    case "FETCH_DOCUMENTS_APP_REF_FULFILLED": {
      const {data, nbResult} = action.payload.data;
      let selected = data.map(event => event.id+"");
      selected = selected.filter(x => !!x);
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data ? data : [],
        selected: selected,
        nbResult: nbResult
      };
    }

    case "FETCH_DOCUMENTS_APP_REF_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        nbResult: 0,
        error
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/appRefFilterReducer.js